<template>
    <div class="principal">
        <NavBar :usarAberto="true" :usarHistorico="false" :usarVoltar="true" :usarDeslogar="false" :usarGerenciar="false"
            :usarRelatorio="false" :usarFiltroSetor="false" :usarFiltroTpChamado="false" :usarFiltroPosicao="false"
            :formatarDataInicioMes="formatarDataInicioMes" />
        <div class="d-flex flex-wrap justify-content-around" id="divCard" v-if="erro == null">
            <CardEquipamento v-for="equip in state.equipamentos" :key="equip.id" :equip="equip" />
        </div>
    </div>
</template>

<script setup>
import api from '@/api/api';
import CardEquipamento from '@/components/CardEquipamento.vue';
import NavBar from '@/components/NavBar.vue';
import store from '@/store/store';
import router from '@/roteador/indexRoteador';
import { reactive, onMounted, computed, defineProps } from 'vue';

const props = defineProps(['formatarDataInicioMes']);

const state = reactive({
    equipamentos: []
});

function iniciar() {
    api.listarEquipamento(true)
        .then(resposta => {
            state.equipamentos = resposta;
        })
        .catch(erro => {
            console.log(erro);
        });
}

function excluir(id) {
    state.equipamentos = state.equipamentos.filter(eq => eq.id != id);
}

function adicionar(equip) {
    state.equipamentos.push(equip);
}

function voltar() {
    router.back();
}

function deslogar() {
    sessionStorage.removeItem("TokenReguaPainel");
    router.back();
}

function cronometro() {
    setTimeout(() => {
        setInterval(() => {
            iniciar();
        }, 6000 * config.value.atualizacao
        );
    }, 2000);
}

onMounted(() => {
    iniciar();
    cronometro();
});

const config = computed(() => {
    return store.state.config;
});

const temporizadorLigado = computed(() => {
    return (store.state.config.cronometro) ? true : false;
});
</script>